import Alpine from 'alpinejs';

Alpine.data('documentsTemplates', (adminURL, type) => ({
  adminURL,
  errors: [],
  loading: false,
  items: [],
  init() {
    this.fetchDocuments();
  },
  fetchDocuments() {
    this.loading = true;

    const formData = new FormData();
    formData.append('action', 'getDocumentsTemplates');

    fetch(this.adminURL, {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        this.loading = false;

        this.items = res;
      });
  },
}));
